/* =============================================================
   RONCASA — NEW LAUNCH DASHBOARD JS
   Handles: ticker pause/resume, carousel drag, chart rendering
   Vanilla JS only. No dependencies.
   ============================================================= */

(function () {
  'use strict';

  /* ── 1. TICKER — pause on hover/tap, tap-to-navigate ──────── */
  function initTickers() {
    document.querySelectorAll('.nl-ticker-row').forEach(function (row) {
      var track = row.querySelector('.nl-ticker-track');
      if (!track) return;

      // Desktop: pause on hover
      row.addEventListener('mouseenter', function () {
        row.classList.add('is-paused');
      });
      row.addEventListener('mouseleave', function () {
        row.classList.remove('is-paused');
      });

      // Mobile: first tap pauses, second tap on same item follows link
      var pausedByTouch = false;
      var lastTouchTarget = null;

      row.addEventListener('touchstart', function (e) {
        if (!pausedByTouch) {
          // First touch: pause only
          row.classList.add('is-paused');
          pausedByTouch = true;
          lastTouchTarget = e.target.closest('.nl-ticker-item');
          e.preventDefault(); // prevent accidental navigation on first tap
        } else {
          // Second touch: if same item, follow link
          var tapped = e.target.closest('.nl-ticker-item');
          if (tapped && tapped === lastTouchTarget && tapped.href) {
            window.location.href = tapped.href;
          } else {
            // Different item or not a link — re-set target, stay paused
            lastTouchTarget = tapped;
          }
        }
      }, { passive: false });

      // Resume if touch moves away from ticker wrap
      row.addEventListener('touchcancel', function () {
        row.classList.remove('is-paused');
        pausedByTouch = false;
        lastTouchTarget = null;
      });

      // Resume on scroll (user swiped the page)
      window.addEventListener('scroll', function () {
        if (pausedByTouch) {
          row.classList.remove('is-paused');
          pausedByTouch = false;
          lastTouchTarget = null;
        }
      }, { passive: true });
    });
  }

  /* ── 1b. TICKER PACE — equalise px/sec across rows of different
     length (fixes rows with more items visibly racing to finish a
     "seconds per loop" duration; same fix as market-ticker.liquid) ── */
  function syncTickerSpeeds() {
    document.querySelectorAll('.nl-ticker-track[data-ticker-speed]').forEach(function (track) {
      var pace = parseFloat(track.getAttribute('data-ticker-speed'));
      if (!pace) return;
      // Content is duplicated x2 in Liquid for the seamless -50% loop -- measure one copy.
      var halfWidth = track.scrollWidth / 2;
      if (!halfWidth) return;
      track.style.animationDuration = (halfWidth / pace) + 's';
    });
  }

  /* ── 2. CAROUSEL — mouse drag + arrow nav ─────────────────── */
  function initCarousels() {
    document.querySelectorAll('.nl-carousel-track').forEach(function (track) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      track.addEventListener('mousedown', function (e) {
        isDown = true;
        track.classList.add('is-dragging');
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        e.preventDefault();
      });

      track.addEventListener('mouseleave', function () {
        isDown = false;
        track.classList.remove('is-dragging');
      });

      track.addEventListener('mouseup', function () {
        isDown = false;
        track.classList.remove('is-dragging');
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5;
        track.scrollLeft = scrollLeft - walk;
      });

      // Prevent card link click if user was dragging
      track.addEventListener('click', function (e) {
        if (track.classList.contains('is-dragging')) {
          e.preventDefault();
        }
      }, { capture: true });
    });

    // Arrow nav buttons
    document.querySelectorAll('.nl-rr-nav-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var regionRow = btn.closest('.nl-region-row');
        if (!regionRow) return;
        var track = regionRow.querySelector('.nl-carousel-track');
        if (!track) return;
        var dir = btn.dataset.dir === 'prev' ? -1 : 1;
        var cardWidth = track.querySelector('.nl-cc')
          ? track.querySelector('.nl-cc').offsetWidth + 14
          : 262;
        track.scrollBy({ left: dir * cardWidth * 2, behavior: 'smooth' });
      });
    });
  }

  /* ── 3. SUPPLY CHART — render from metafield data ─────────── */
  function renderSupplyChart() {
    var canvas = document.getElementById('nl-supply-chart-svg');
    if (!canvas) return;

    var dataEl = document.getElementById('nl-supply-data');
    if (!dataEl) return;

    var raw;
    try { raw = JSON.parse(dataEl.textContent); }
    catch (e) { return; }

    if (!raw || !raw.districts) return;

    var districts = raw.districts; // [{label:"D9", units:1400}, ...]
    var maxVal = districts.reduce(function (m, d) { return Math.max(m, d.units); }, 0);
    var W = 900, H = 228;
    var barW = 52, gap = 78, startX = 70, topPad = 18, bottomPad = 32, leftPad = 58;
    var chartH = H - topPad - bottomPad;

    var svgParts = [];

    // Grid lines + y-labels
    var steps = [0, 500, 1000, 1500, 2000];
    steps.forEach(function (s) {
      var y = topPad + chartH - (s / maxVal) * chartH;
      svgParts.push('<line x1="' + leftPad + '" y1="' + y + '" x2="' + (W - 10) + '" y2="' + y + '" stroke="#E0E0E0" stroke-width="1"/>');
      svgParts.push('<text x="4" y="' + (y + 4) + '" font-family="JetBrains Mono" font-size="10" fill="#8A8A8A">' + s + '</text>');
    });

    // Bars + x-labels
    districts.forEach(function (d, i) {
      var barH = (d.units / maxVal) * chartH;
      var x = startX + (i * (barW + gap - barW));
      var y = topPad + chartH - barH;
      var opacity = 0.45 + (d.units / maxVal) * 0.5;
      svgParts.push('<rect x="' + x + '" y="' + y + '" width="' + barW + '" height="' + barH + '" rx="1" fill="#1A1A1A" opacity="' + opacity.toFixed(2) + '"/>');
      svgParts.push('<text x="' + (x + barW / 2) + '" y="' + (H - 6) + '" font-family="JetBrains Mono" font-size="10" fill="#8A8A8A" text-anchor="middle">' + d.label + '</text>');
    });

    canvas.innerHTML = svgParts.join('');
  }

  /* ── 4. ABSORPTION CHART — render from metafield data ──────── */
  function renderAbsorptionChart() {
    var canvas = document.getElementById('nl-abs-chart-svg');
    if (!canvas) return;

    var dataEl = document.getElementById('nl-abs-data');
    if (!dataEl) return;

    var raw;
    try { raw = JSON.parse(dataEl.textContent); }
    catch (e) { return; }

    if (!raw || !raw.points) return;

    var points = raw.points; // [{label:"Q3 25", pct:57}, ...]
    var W = 640, H = 200;
    var leftPad = 52, rightPad = 20, topPad = 12, bottomPad = 32;
    var chartW = W - leftPad - rightPad;
    var chartH = H - topPad - bottomPad;

    var toX = function (i) { return leftPad + (i / (points.length - 1)) * chartW; };
    var toY = function (pct) { return topPad + chartH - (pct / 100) * chartH; };

    var svgParts = [];

    // Grid lines
    [25, 50, 75, 100].forEach(function (p) {
      var y = toY(p);
      svgParts.push('<line x1="' + leftPad + '" y1="' + y + '" x2="' + (W - rightPad) + '" y2="' + y + '" stroke="#E0E0E0" stroke-width="1"/>');
      svgParts.push('<text x="4" y="' + (y + 4) + '" font-family="JetBrains Mono" font-size="10" fill="#8A8A8A">' + p + '%</text>');
    });

    // Trend line
    var linePts = points.map(function (p, i) { return toX(i) + ',' + toY(p.pct); }).join(' ');
    svgParts.push('<polyline fill="none" stroke="#1A1A1A" stroke-width="2.5" points="' + linePts + '"/>');

    // Dots
    points.forEach(function (p, i) {
      var isLast = i === points.length - 1;
      svgParts.push('<circle cx="' + toX(i) + '" cy="' + toY(p.pct) + '" r="' + (isLast ? '4.5' : '3.5') + '" fill="' + (isLast ? '#C0392B' : '#1A1A1A') + '"/>');
    });

    // X labels
    points.forEach(function (p, i) {
      svgParts.push('<text x="' + toX(i) + '" y="' + (H - 4) + '" font-family="JetBrains Mono" font-size="10" fill="#8A8A8A" text-anchor="middle">' + p.label + '</text>');
    });

    canvas.innerHTML = svgParts.join('');
  }

  /* ── 5. SCORE BAR ANIMATION ─────────────────────────────────── */
  function animateScoreBars() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var fill = entry.target;
          fill.style.width = fill.dataset.score + '%';
          observer.unobserve(fill);
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('.nl-score__fill[data-score]').forEach(function (el) {
      el.style.width = '0%';
      observer.observe(el);
    });
  }

  /* ── 6. SECTION NAV — active state on scroll ─────────────────── */
  function initSectNav() {
    var navLinks = document.querySelectorAll('.nl-sect-nav__link[href^="#"]');
    if (!navLinks.length) return;

    var sections = Array.from(navLinks).map(function (a) {
      return document.querySelector(a.getAttribute('href'));
    }).filter(Boolean);

    var lastActive = null;
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY + 120;
      var active = sections[0];
      sections.forEach(function (s) {
        if (s.offsetTop <= scrollY) active = s;
      });
      var activeLink = null;
      navLinks.forEach(function (a) {
        var target = document.querySelector(a.getAttribute('href'));
        var isActive = target === active;
        a.classList.toggle('nl-sect-nav__link--active', isActive);
        if (isActive) activeLink = a;
      });
      if (active !== lastActive) {
        lastActive = active;
        if (activeLink) activeLink.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }, { passive: true });
  }

  /* ── INIT ──────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initTickers();
    syncTickerSpeeds();
    initCarousels();
    renderSupplyChart();
    renderAbsorptionChart();
    animateScoreBars();
    initSectNav();
  });
  window.addEventListener('resize', syncTickerSpeeds);
  window.addEventListener('load', syncTickerSpeeds); // re-measure after fonts settle

})();
